import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      Made By Abhishek Pathak
    </footer>
  );
};

export default Footer;
